export default __webpack_public_path__ + "static/media/ic_ethereum_96.77db9d2e.svg";